import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { gameStore } from '../game/store';
import { storyBeats } from '../game/dialogue';
const SPEAKER_STYLES = {
  narrator: {
    color: 'text-gray-300',
    label: ''
  },
  carl: {
    color: 'text-blue-300',
    label: 'CARL'
  },
  system: {
    color: 'text-red-400',
    label: '/// THE SYSTEM ///'
  },
  mordecai: {
    color: 'text-emerald-300',
    label: 'MORDECAI'
  },
  donut: {
    color: 'text-pink-300',
    label: 'PRINCESS DONUT'
  },
  gnome: {
    color: 'text-amber-300',
    label: 'MRS. WARTBOTTOM'
  },
  goblin_king: {
    color: 'text-purple-400',
    label: 'THE GOBLIN KING'
  }
};
export function ColdOpen() {
  const lines = storyBeats.cold_open;
  const [index, setIndex] = useState(0);
  const [skipped, setSkipped] = useState(false);
  useEffect(() => {
    if (index >= lines.length) {
      // Finish cold open -> transition to playing
      setTimeout(() => {
        gameStore.setState({
          phase: 'playing'
        });
      }, 800);
      return;
    }
    const line = lines[index];
    const dur = line.duration || 4000;
    const t = setTimeout(() => setIndex(i => i + 1), dur);
    return () => clearTimeout(t);
  }, [index, lines]);
  const handleSkip = () => {
    setSkipped(true);
    setTimeout(() => gameStore.setState({
      phase: 'playing'
    }), 400);
  };
  const handleAdvance = () => {
    if (index < lines.length - 1) setIndex(i => i + 1);else handleSkip();
  };
  if (skipped || index >= lines.length) {
    return <motion.div initial={{
      opacity: 1
    }} animate={{
      opacity: 0
    }} transition={{
      duration: 0.6
    }} className="absolute inset-0 z-50 bg-black pointer-events-none" data-id="element-10" />;
  }
  const line = lines[index];
  const style = SPEAKER_STYLES[line.speaker] || SPEAKER_STYLES.narrator;
  return <div className="absolute inset-0 z-50 bg-black flex flex-col items-center justify-center pointer-events-auto cursor-pointer" onClick={handleAdvance} data-id="element-11">
      {/* Vignette */}
      <div className="absolute inset-0" style={{
      background: 'radial-gradient(ellipse at center, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 70%, rgba(0,0,0,1) 100%)',
      pointerEvents: 'none'
    }} data-id="element-12" />

      {/* Flickering static */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(255,255,255,0.1) 2px, rgba(255,255,255,0.1) 3px)'
    }} data-id="element-13" />

      {/* Progress dots */}
      <div className="absolute top-8 flex gap-1.5 pointer-events-none" data-id="element-14">
        {lines.map((_, i) => <div key={i} className={`h-0.5 w-8 transition-colors duration-300 ${i < index ? 'bg-red-700' : i === index ? 'bg-red-500' : 'bg-gray-800'}`} data-id="element-15" />)}
      </div>

      {/* Main text */}
      <div className="max-w-3xl px-8 text-center z-10" data-id="element-16">
        <AnimatePresence mode="wait" data-id="element-17">
          <motion.div key={index} initial={{
          opacity: 0,
          y: 10,
          filter: 'blur(4px)'
        }} animate={{
          opacity: 1,
          y: 0,
          filter: 'blur(0px)'
        }} exit={{
          opacity: 0,
          y: -10,
          filter: 'blur(4px)'
        }} transition={{
          duration: 0.6
        }} data-id="element-18">
            {style.label && <div className={`${style.color} text-xs uppercase tracking-[0.4em] mb-6 opacity-70`} data-id="element-19">
                {style.label}
              </div>}
            <div className={`${style.color} ${line.speaker === 'system' ? 'font-black text-2xl md:text-4xl tracking-wider uppercase glitch-active' : 'text-xl md:text-3xl tracking-wide italic'} leading-relaxed`} data-id="element-20">
              {line.text}
            </div>
          </motion.div>
        </AnimatePresence>
      </div>

      {/* Footer */}
      <div className="absolute bottom-8 text-gray-600 text-xs uppercase tracking-widest pointer-events-none" data-id="element-21">
        Click anywhere to advance · {index + 1} / {lines.length}
      </div>

      <button onClick={e => {
      e.stopPropagation();
      handleSkip();
    }} className="absolute bottom-8 right-8 text-gray-700 hover:text-gray-400 text-xs uppercase tracking-widest transition-colors" data-id="element-22">
        Skip intro →
      </button>
    </div>;
}